import { Modal, Tabs, TabsProps } from 'antd'
import { useDispatch } from 'react-redux'
import { Customer } from 'src/common/models/customer'
import { CustomerForm } from 'src/features/Customer/CustomerForm'
import { updateCurrentContract } from 'src/features/ServiceContract/state/action'
import { ClientSelector } from './ClientSelector'
import { SystemDescriptions } from 'src/common/descriptions'

interface Props {
    open: boolean
    onCancel: VoidFunction
    onAccept: VoidFunction
    okText: string
    cancelText: string
}

export const CreateTicketCustomer = (props: Props) => {
    const dispatch = useDispatch()

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT

    const onFinish = (customer: Partial<Customer>) => {
        dispatch(updateCurrentContract({
            customer: { ...customer }
        }))
        props.onAccept()
    }

    const onChange = (key: string) => {
    };

    const items: TabsProps['items'] = [
        {
            key: 'CREATE_CUSTOMER',
            label: descriptions.CUSTOMER.TAB_CREATE,
            children: <CustomerForm
                onFinish={onFinish}
                onCancel={props.onCancel} />,
        },
        {
            key: 'SELECT_CUSTOMER',
            label: descriptions.CUSTOMER.TAB_SELECT,
            children: <ClientSelector
                onAccept={onFinish}
                onCancel={() => { props.onCancel() }}
            />,
        },
    ];

    const renderContent = () => (
        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    )


    return (
        <Modal
            title={descriptions.CUSTOMER.TITLE}
            centered
            open={props.open}
            width={1000}
            onOk={props.onAccept}
            okText={props.okText}
            closable={false}
            footer={<></>}
            zIndex={1200}
            getContainer={false}
            destroyOnClose={true}
        >
            {renderContent()}
        </Modal>
    )
}
